import { api, getAuthHeader } from './help';

export const getLandlord = async (data) => {
  const response = await api.get('/claim/landlord?state=' + data.state, getAuthHeader());
  return response.data;
};

export const getProperty = async (data) => {
  const response = await api.get(
    '/claim/property?state=' + data.state + '&landlordId=' + data.landlordId,
    getAuthHeader(),
  );
  return response.data;
};

export const getRider = async (data) => {
  const response = await api.get('/claim/rider?propertyId=' + data.propertyId, getAuthHeader());
  return response.data;
};

export const createClaim = async (data) => {
  const response = await api.post('/claim/create', data, getAuthHeader());
  return response.data;
};

export const checkPolicyDuplicated = async (data) => {
  const riderId = typeof data === 'string' ? data : data?.riderId;
  const response = await api.get('/claim/claim-duplicated?riderId=' + riderId, getAuthHeader());
  return response.data;
};

export const getLandlordStateById = async (landlord_id) => {
  const response = await api.get('/claim/getLandlordState?id=' + landlord_id, getAuthHeader());
  return response.data;
};

export const getTenants = async (policyId) => {
  const response = await api.get('/claim/tenants?policyId=' + policyId, getAuthHeader());
  return response.data;
};

export const lookupPolicy = async (riderNumber) => {
  const response = await api.post('/claim/policy/lookup', { riderNumber }, getAuthHeader());
  return response.data;
};
